module.exports = __webpack_public_path__ + "static/IMG-5-2435e3e2201e5eec93c04e42cb3cba4a.jpg";